import { useQuery } from '@apollo/client';
import { Stack } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import useCompanyContext from 'common/hooks/useCompanyContext';
import SunshineCard from 'components/_core/SunshineCard';

import { Item } from './components/Item';
import { ItemSkeleton } from './components/ItemSkeleton';
import { ShineRecurringExportsDocument } from './graphql/shineRecurringExports.gql';
import locales from './locales';

export const RecurringExportsList = () => {
  const { companyProfileId } = useCompanyContext();
  const { data, loading } = useQuery(ShineRecurringExportsDocument, {
    variables: { companyProfileId: companyProfileId || '' },
  });

  const shineRecurringExportSettings =
    data?.viewer.company.shineRecurringAccountingExportSettings ?? [];

  return (
    <Stack>
      <Typography.Text size="small" variant="discreet">
        {locales.title}
      </Typography.Text>

      {!data && loading ? <ItemSkeleton /> : null}

      {shineRecurringExportSettings.length ? (
        <SunshineCard.Group>
          {shineRecurringExportSettings.map((recurringExport) => (
            <Item
              accountingExportSettingsId={
                recurringExport.accountingExportSettingsId
              }
              key={recurringExport.accountingExportSettingsId}
              nextExportAt={recurringExport.nextExportAt}
            />
          ))}
        </SunshineCard.Group>
      ) : null}
    </Stack>
  );
};
